import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SocialImpactRoutingModule } from './social-impact-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MaterialModule } from 'src/app/material.module';
import { SocialImpactPageComponent } from './components/social-impact-page/social-impact-page.component';
import { AdminSocialImpactComponent } from './components/admin-social-impact/admin-social-impact.component';


@NgModule({
  declarations: [SocialImpactPageComponent, AdminSocialImpactComponent],
  imports: [
    CommonModule,
    SocialImpactRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ]
})
export class SocialImpactModule { }
